"use strict";

var _interopRequireWildcard = require("@babel/runtime-corejs2/helpers/interopRequireWildcard");

var _interopRequireDefault = require("@babel/runtime-corejs2/helpers/interopRequireDefault");

var _Object$defineProperty2 = require("@babel/runtime-corejs2/core-js/object/define-property");

_Object$defineProperty2(exports, "__esModule", {
  value: true
});

exports["default"] = exports.ERV_PAGE_TYPES = exports.WIZARD_FN_TYPES = void 0;

var _defineProperty2 = _interopRequireDefault(require("@babel/runtime-corejs2/core-js/object/define-property"));

var _defineProperties = _interopRequireDefault(require("@babel/runtime-corejs2/core-js/object/define-properties"));

var _getOwnPropertyDescriptors = _interopRequireDefault(require("@babel/runtime-corejs2/core-js/object/get-own-property-descriptors"));

var _getOwnPropertyDescriptor = _interopRequireDefault(require("@babel/runtime-corejs2/core-js/object/get-own-property-descriptor"));

var _getOwnPropertySymbols = _interopRequireDefault(require("@babel/runtime-corejs2/core-js/object/get-own-property-symbols"));

var _getIterator2 = _interopRequireDefault(require("@babel/runtime-corejs2/core-js/get-iterator"));

var _isArray = _interopRequireDefault(require("@babel/runtime-corejs2/core-js/array/is-array"));

var _iterator2 = _interopRequireDefault(require("@babel/runtime-corejs2/core-js/symbol/iterator"));

var _symbol = _interopRequireDefault(require("@babel/runtime-corejs2/core-js/symbol"));

var _from = _interopRequireDefault(require("@babel/runtime-corejs2/core-js/array/from"));

var _construct = _interopRequireDefault(require("@babel/runtime-corejs2/core-js/reflect/construct"));

var _keys = _interopRequireDefault(require("@babel/runtime-corejs2/core-js/object/keys"));

var _toConsumableArray2 = _interopRequireDefault(require("@babel/runtime-corejs2/helpers/toConsumableArray"));

var _assign = _interopRequireDefault(require("@babel/runtime-corejs2/core-js/object/assign"));

var _parseInt2 = _interopRequireDefault(require("@babel/runtime-corejs2/core-js/parse-int"));

var _regenerator = _interopRequireDefault(require("@babel/runtime-corejs2/regenerator"));

var _asyncToGenerator2 = _interopRequireDefault(require("@babel/runtime-corejs2/helpers/asyncToGenerator"));

var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime-corejs2/helpers/classCallCheck"));

var _createClass2 = _interopRequireDefault(require("@babel/runtime-corejs2/helpers/createClass"));

var _assertThisInitialized2 = _interopRequireDefault(require("@babel/runtime-corejs2/helpers/assertThisInitialized"));

var _inherits2 = _interopRequireDefault(require("@babel/runtime-corejs2/helpers/inherits"));

var _possibleConstructorReturn2 = _interopRequireDefault(require("@babel/runtime-corejs2/helpers/possibleConstructorReturn"));

var _get2 = _interopRequireDefault(require("@babel/runtime-corejs2/helpers/get"));

var _getPrototypeOf2 = _interopRequireDefault(require("@babel/runtime-corejs2/helpers/getPrototypeOf"));

var _defineProperty3 = _interopRequireDefault(require("@babel/runtime-corejs2/helpers/defineProperty"));

var _react = _interopRequireDefault(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _reactFontawesome = _interopRequireDefault(require("react-fontawesome"));

var _AppCordova = _interopRequireDefault(require("../../../../targets/cord_eurofh_teams/AppCordova.js"));

var _PreconditionChecker = require("../../../utils/PreconditionChecker");

var _ArrayHelper = require("../../../helpers/ArrayHelper");

var _KESI2BasicComponent = _interopRequireDefault(require("../../../KESI2/KESI2BasicComponent"));

var _KesiConstants = require("../../../KESI2/KesiConstants");

var _KESI2Helper = _interopRequireDefault(require("../../../KESI2/KESI2Helper"));

var _RelevancesService = require("../../../KESI2/Services/RelevancesService");

var _ErvNestedTiles = _interopRequireDefault(require("./ErvNestedTiles.scss"));

var _TimeoutHelper = require("../../../helpers/TimeoutHelper");

var _FeatureManager = _interopRequireDefault(require("../../../utils/features/FeatureManager"));

var _config = _interopRequireDefault(require("../../../../targets/cord_eurofh_teams/config.js"));

var _cssConstants = _interopRequireDefault(require("../../../../targets/cord_eurofh_teams/cssConstants.js"));

var _DrupalNestedTileSizes = require("./DrupalNestedTileSizes");

var _DeviceInfoHelper = _interopRequireDefault(require("../../../helpers/DeviceInfoHelper"));

var _DataStore = _interopRequireWildcard(require("../../../KESI2/Stores/DataStore2"));

var _ErvFront = _interopRequireDefault(require("./ErvFront"));

var _PreconditionActionExecutioner = require("../../../utils/PreconditionActionExecutioner");

var _FlexMenuHelper = require("../../../helpers/FlexMenuHelper");

var _PageSlide = _interopRequireDefault(require("../PageSlide/PageSlide"));

var _LogService = _interopRequireWildcard(require("../../../KESI2/Services/LogService"));

var _strings = require("../../../../config/strings");

var _TilesColorHelper = _interopRequireDefault(require("./TilesColorHelper"));

var _NavigationManagerCordova = _interopRequireDefault(require("../../NavigationManagerCordova"));

var _ProgressBar = _interopRequireDefault(require("./ProgressBar"));

var _Constants = require("../../constants/Constants");

var _DateTimeHelper = require("../../../helpers/DateTimeHelper");

var _icons = require("@material-ui/icons");

var _KeyboardArrowDown = _interopRequireDefault(require("@material-ui/icons/KeyboardArrowDown"));

var _Nugget = _interopRequireDefault(require("./Nuggets/Nugget.scss"));

function ownKeys(object, enumerableOnly) { var keys = (0, _keys["default"])(object); if (_getOwnPropertySymbols["default"]) { var symbols = (0, _getOwnPropertySymbols["default"])(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return (0, _getOwnPropertyDescriptor["default"])(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { (0, _defineProperty3["default"])(target, key, source[key]); }); } else if (_getOwnPropertyDescriptors["default"]) { (0, _defineProperties["default"])(target, (0, _getOwnPropertyDescriptors["default"])(source)); } else { ownKeys(Object(source)).forEach(function (key) { (0, _defineProperty2["default"])(target, key, (0, _getOwnPropertyDescriptor["default"])(source, key)); }); } } return target; }

function _createForOfIteratorHelper(o, allowArrayLike) { var it; if (typeof _symbol["default"] === "undefined" || o[_iterator2["default"]] == null) { if ((0, _isArray["default"])(o) || (it = _unsupportedIterableToArray(o)) || allowArrayLike && o && typeof o.length === "number") { if (it) o = it; var i = 0; var F = function F() {}; return { s: F, n: function n() { if (i >= o.length) return { done: true }; return { done: false, value: o[i++] }; }, e: function e(_e) { throw _e; }, f: F }; } throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); } var normalCompletion = true, didErr = false, err; return { s: function s() { it = (0, _getIterator2["default"])(o); }, n: function n() { var step = it.next(); normalCompletion = step.done; return step; }, e: function e(_e2) { didErr = true; err = _e2; }, f: function f() { try { if (!normalCompletion && it["return"] != null) it["return"](); } finally { if (didErr) throw err; } } }; }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return (0, _from["default"])(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = (0, _getPrototypeOf2["default"])(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = (0, _getPrototypeOf2["default"])(this).constructor; result = (0, _construct["default"])(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return (0, _possibleConstructorReturn2["default"])(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !_construct["default"]) return false; if (_construct["default"].sham) return false; if (typeof Proxy === "function") return true; try { Date.prototype.toString.call((0, _construct["default"])(Date, [], function () {})); return true; } catch (e) { return false; } }

var Z_INDEX = {
  BACKGROUND: 0,
  FOREGROUND: 1
};
var WIZARD_FN_TYPES = {
  CLOSE: 'close',
  NEXT: 'next',
  BACK: 'back'
};
exports.WIZARD_FN_TYPES = WIZARD_FN_TYPES;
var ERV_PAGE_TYPES = {
  SEC_PROFILE: 'securityProfile',
  CORONA: 'corona'
};
exports.ERV_PAGE_TYPES = ERV_PAGE_TYPES;

var NonFlippingGenericTiles = /*#__PURE__*/function (_Kesi2BasicComponent) {
  (0, _inherits2["default"])(NonFlippingGenericTiles, _Kesi2BasicComponent);

  var _super = _createSuper(NonFlippingGenericTiles);

  function NonFlippingGenericTiles(props, context) {
    var _thisSuper, _this;

    (0, _classCallCheck2["default"])(this, NonFlippingGenericTiles);
    _this = _super.call(this, props, context, _KESI2Helper["default"].getLastSpocOrCourseId(props.contentPathArray));
    (0, _defineProperty3["default"])((0, _assertThisInitialized2["default"])(_this), "getVisibleTileCount", function (tiles) {
      var count = 0;
      tiles.forEach(function (tile) {
        var failingPrecondition = (0, _PreconditionChecker.getFailingPrecondition)(tile.showPrecondition);

        if (!failingPrecondition) {
          count++;
        }
      });
      return count;
    });
    (0, _defineProperty3["default"])((0, _assertThisInitialized2["default"])(_this), "checkScrollTop", /*#__PURE__*/function () {
      var _ref = (0, _asyncToGenerator2["default"])( /*#__PURE__*/_regenerator["default"].mark(function _callee(data) {
        var counter,
            scrollElement,
            newCounter,
            _args = arguments;
        return _regenerator["default"].wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                counter = _args.length > 1 && _args[1] !== undefined ? _args[1] : 20;
                scrollElement = document.getElementById(_this.getFrameElementId());

                if (!(scrollElement.scrollTop === _this.frameScrollTop && counter > 0)) {
                  _context.next = 7;
                  break;
                }

                _context.next = 5;
                return (0, _TimeoutHelper.timeout)(50);

              case 5:
                newCounter = counter - 1;
                return _context.abrupt("return", _this.checkScrollTop(data, newCounter));

              case 7:
                if (scrollElement) {
                  scrollElement.scrollTop = _this.frameScrollTop;
                }

              case 8:
              case "end":
                return _context.stop();
            }
          }
        }, _callee);
      }));

      return function (_x) {
        return _ref.apply(this, arguments);
      };
    }());
    (0, _defineProperty3["default"])((0, _assertThisInitialized2["default"])(_this), "setLectureTitle", /*#__PURE__*/function () {
      var _ref2 = (0, _asyncToGenerator2["default"])( /*#__PURE__*/_regenerator["default"].mark(function _callee2(id) {
        var content, titleKey, title, colorToUse;
        return _regenerator["default"].wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                if (_config["default"].cordovaStartUrl().indexOf(id) !== -1) {
                  _this.props.setBackButtonFunc(null); // start tile -> set the logo


                  _this.props.setTitle(null);

                  _NavigationManagerCordova["default"].setNavbarBackgroundColor(null);
                } else {
                  content = _KESI2Helper["default"].getContentById(id);
                  titleKey = content && content.itemid ? "".concat(content.itemid, "_title") : null;
                  title = titleKey ? (0, _strings.getString)(titleKey) : null;

                  _this.props.setTitle(title);

                  if (_config["default"].useTileBackgroundColorInTile && content && (content.backgroundColor || content.innerColor)) {
                    colorToUse = content.innerColor ? content.innerColor : content.backgroundColor;

                    _NavigationManagerCordova["default"].setNavbarBackgroundColor(colorToUse);
                  }
                }

              case 1:
              case "end":
                return _context2.stop();
            }
          }
        }, _callee2);
      }));

      return function (_x2) {
        return _ref2.apply(this, arguments);
      };
    }());
    (0, _defineProperty3["default"])((0, _assertThisInitialized2["default"])(_this), "closeTileWithoutAnimation", /*#__PURE__*/function () {
      var _ref3 = (0, _asyncToGenerator2["default"])( /*#__PURE__*/_regenerator["default"].mark(function _callee3(domId) {
        var force,
            el,
            id,
            overlay,
            _args3 = arguments;
        return _regenerator["default"].wrap(function _callee3$(_context3) {
          while (1) {
            switch (_context3.prev = _context3.next) {
              case 0:
                force = _args3.length > 1 && _args3[1] !== undefined ? _args3[1] : false;

                if (_this.state.navigationAllowed) {
                  _context3.next = 3;
                  break;
                }

                return _context3.abrupt("return");

              case 3:
                _this.checkForDemoMode();

                _this.setState({
                  tileToOpen: null,
                  animatedContent: null,
                  animatedDomId: null,
                  expandedTile: null,
                  openTileDomId: null,
                  navigationAllowed: false,
                  tileClosing: true,
                  tileOpenedAutomatically: false,
                  openTilePosBeforeOpening: null
                });

                el = document.getElementById(domId);
                el.classList.remove(_ErvNestedTiles["default"].tileOpen);
                el.scrollTop = 0;
                id = _KESI2Helper["default"].getLastSpocOrCourseId(_this.props.contentPathArray) || _this.props.contentPathArray[_this.props.contentPathArray.length - 1];
                (0, _LogService["default"])(id, _this.props.contentPathArray.slice(0, _this.props.contentPathArray));

                _this.setLectureTitle(id);

                el.style.transform = "translate3d(0, 0, 0)";
                el.style.width = "".concat(_this.state.oldWidth, "px");
                el.style.removeProperty('height');
                el.style.position = 'relative';
                el.style.overflow = 'hidden';

                _this.setState({
                  animatedTile: null
                });

                overlay = document.getElementById('overlay');

                if (overlay) {
                  overlay.style.opacity = 0;
                }

                _this.setState({
                  expandedTile: null,
                  openTileDomId: null
                });

                _this.setState({
                  showOverlay: false,
                  navigationAllowed: true
                });

                _this.setState({
                  tileClosing: false
                });

                el.parentElement.style.zIndex = 0;

                _this.setState({
                  overflowYHidden: false
                });

              case 24:
              case "end":
                return _context3.stop();
            }
          }
        }, _callee3);
      }));

      return function (_x3) {
        return _ref3.apply(this, arguments);
      };
    }());
    (0, _defineProperty3["default"])((0, _assertThisInitialized2["default"])(_this), "closeTile", /*#__PURE__*/function () {
      var _ref4 = (0, _asyncToGenerator2["default"])( /*#__PURE__*/_regenerator["default"].mark(function _callee4(domId) {
        var el, id, overlay, bottomBar;
        return _regenerator["default"].wrap(function _callee4$(_context4) {
          while (1) {
            switch (_context4.prev = _context4.next) {
              case 0:
                console.log('closeTile', domId);

                if (_this.state.navigationAllowed) {
                  _context4.next = 3;
                  break;
                }

                return _context4.abrupt("return");

              case 3:
                _this.checkForDemoMode();

                if (!_DeviceInfoHelper["default"].isAndroid()) {
                  _context4.next = 10;
                  break;
                }

                _this.setState({
                  tileToOpen: null,
                  animatedContent: null,
                  animatedDomId: null,
                  expandedTile: null,
                  openTileDomId: null,
                  navigationAllowed: false,
                  tileClosing: true,
                  tileOpenendAutomatically: false,
                  openTilePosBeforeOpening: null
                });

                _context4.next = 8;
                return (0, _TimeoutHelper.timeout)(200);

              case 8:
                _context4.next = 11;
                break;

              case 10:
                _this.setState({
                  tileToOpen: null,
                  animatedContent: null,
                  animatedDomId: null,
                  tileClosing: true,
                  expandedTile: null,
                  openTilePosBeforeOpening: null
                });

              case 11:
                el = document.getElementById(domId);

                if (el) {
                  el.scrollTop = 0;
                  el.classList.remove(_ErvNestedTiles["default"].tileOpen);
                }

                id = _KESI2Helper["default"].getLastSpocOrCourseId(_this.props.contentPathArray) || _this.props.contentPathArray[_this.props.contentPathArray.length - 1];
                (0, _LogService["default"])(id, _this.props.contentPathArray.slice(0, _this.props.contentPathArray));

                _this.setLectureTitle(id);

                if (el) {
                  el.classList.remove(_config["default"].useSimpleTileAnimation ? _ErvNestedTiles["default"].openFast : _ErvNestedTiles["default"].open);
                  el.classList.remove(_ErvNestedTiles["default"].move);
                  el.classList.add(_config["default"].useSimpleTileAnimation ? _ErvNestedTiles["default"].closeFast : _ErvNestedTiles["default"].close);
                  el.style.borderTopLeftRadius = _this.state.openTileBorderRadius ? _this.state.openTileBorderRadius.topLeft : 0;
                  el.style.borderTopRightRadius = _this.state.openTileBorderRadius ? _this.state.openTileBorderRadius.topRight : 0;
                  el.style.borderBottomRightRadius = _this.state.openTileBorderRadius ? _this.state.openTileBorderRadius.bottomRight : 0;
                  el.style.borderBottomLeftRadius = _this.state.openTileBorderRadius ? _this.state.openTileBorderRadius.bottomLeft : 0;
                  el.style.transform = "translate3d(0, 0, 0)";
                  el.style.width = "".concat(_this.state.oldWidth, "px");
                  el.style.removeProperty('height');
                  el.style.position = 'relative';
                }

                if (!_DeviceInfoHelper["default"].isAndroid()) {
                  _context4.next = 22;
                  break;
                }

                _context4.next = 20;
                return (0, _TimeoutHelper.timeout)(500);

              case 20:
                _context4.next = 25;
                break;

              case 22:
                _this.setState({
                  animatedTile: null
                });

                _context4.next = 25;
                return (0, _TimeoutHelper.timeout)(400);

              case 25:
                overlay = document.getElementById('overlay');

                if (overlay) {
                  overlay.style.opacity = 0;
                }

                if (_config["default"].openTilesInFullScreen) {
                  bottomBar = document.getElementById('bottomBar');

                  if (bottomBar) {
                    bottomBar.style.opacity = 1;
                    bottomBar.style.zIndex = 10000;
                  }
                }

                if (!_DeviceInfoHelper["default"].isAndroid()) {
                  _context4.next = 34;
                  break;
                }

                _context4.next = 31;
                return (0, _TimeoutHelper.timeout)(400);

              case 31:
                _this.setState({
                  animatedTile: null,
                  showOverlay: false
                });

                _context4.next = 38;
                break;

              case 34:
                _this.setState({
                  openTileDomId: null,
                  navigationAllowed: true
                });

                _context4.next = 37;
                return (0, _TimeoutHelper.timeout)(500);

              case 37:
                _this.setState({
                  showOverlay: false
                });

              case 38:
                _this.setState({
                  tileClosing: false
                });

                el.parentElement.style.zIndex = 0; // await timeout(500)

                _this.setState({
                  overflowYHidden: false
                });

              case 41:
              case "end":
                return _context4.stop();
            }
          }
        }, _callee4);
      }));

      return function (_x4) {
        return _ref4.apply(this, arguments);
      };
    }());
    (0, _defineProperty3["default"])((0, _assertThisInitialized2["default"])(_this), "checkForDemoMode", /*#__PURE__*/(0, _asyncToGenerator2["default"])( /*#__PURE__*/_regenerator["default"].mark(function _callee5() {
      var demoMode, nextTile, id, path, content, stringPath;
      return _regenerator["default"].wrap(function _callee5$(_context5) {
        while (1) {
          switch (_context5.prev = _context5.next) {
            case 0:
              demoMode = _DataStore["default"].getElementByPathImmediately(_DataStore.DATA_STORE_PATHS.SCHICHTBOX_DEMO_MODE);

              if (!demoMode) {
                _context5.next = 22;
                break;
              }

              _context5.next = 4;
              return (0, _DateTimeHelper.showNextStepAlert)();

            case 4:
              nextTile = _context5.sent;
              console.log('nextTile', nextTile);

              if (!nextTile.goToId) {
                _context5.next = 20;
                break;
              }

              id = nextTile.goToId;
              path = _KESI2Helper["default"].getPathToContentInTree(id);
              content = _KESI2Helper["default"].getContentById(id);
              console.log('navigateTo', id, path, content);

              if (!path) {
                _context5.next = 18;
                break;
              }

              if (path.length > 1 && content.type === 'nugget') {
                // Remove the last element if it was a nugget, cant link to nuggets right now
                (0, _ArrayHelper.removeElementAtPosition)(path, path.length - 1);
              }

              stringPath = "".concat(_config["default"].baseRoute, "/").concat(path.join('!'));

              if (!nextTile.data) {
                _context5.next = 17;
                break;
              }

              _context5.next = 17;
              return _DataStore["default"].setData(nextTile.data);

            case 17:
              _NavigationManagerCordova["default"].goTo(stringPath);

            case 18:
              _context5.next = 22;
              break;

            case 20:
              _this.setState({
                openTileGroup: nextTile.keyword,
                animatedDemoTileId: nextTile.id
              }, function () {
                // triger the precondition after setting the animatedDemoTileId
                if (nextTile.data) {
                  _DataStore["default"].setData(nextTile.data);
                }
              });

              setTimeout(function () {
                _this.setState({
                  animatedDemoTileId: null
                });
              }, 300);

            case 22:
            case "end":
              return _context5.stop();
          }
        }
      }, _callee5);
    })));
    (0, _defineProperty3["default"])((0, _assertThisInitialized2["default"])(_this), "tileContentDidMount", function () {
      var hideTileAnimation = _DataStore["default"].getElementByPathImmediately(_DataStore.DATA_STORE_PATHS.KESI_HIDE_TILE_ANIMATION) || false;

      if (hideTileAnimation) {
        _this.openTileWithoutAnimation();
      } else {
        _this.openTile();
      }
    });
    (0, _defineProperty3["default"])((0, _assertThisInitialized2["default"])(_this), "setOpenTile", function (content) {
      var wasClicked = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : true;

      if (_this.state.tileClosing) {
        return;
      }

      (0, _LogService["default"])(content.id, _this.props.contentPathArray.join(_KesiConstants.KESI_PATH_DELIMITER));

      var domId = _this.getTileIdForContent(content.id);

      var state = {
        tileToOpen: content.id,
        animatedContent: content,
        animatedDomId: domId
      };

      if (!wasClicked) {
        state.tileOpenedAutomatically = true;
      }

      _this.setState(state);
    });
    (0, _defineProperty3["default"])((0, _assertThisInitialized2["default"])(_this), "getInsetTop", function () {
      if (CSS.supports('padding-top: constant(safe-area-inset-top)')) {
        var div = document.createElement('div');
        div.style.paddingTop = 'constant(safe-area-inset-top)';
        document.body.appendChild(div);
        var calculatedPadding = (0, _parseInt2["default"])(window.getComputedStyle(div).paddingTop, 10);
        document.body.removeChild(div);
        var valueToReturn = _cssConstants["default"].safeAreaTopDivisor ? calculatedPadding / _cssConstants["default"].safeAreaTopDivisor : calculatedPadding;
        return valueToReturn;
      }

      if (CSS.supports('padding-top: env(safe-area-inset-top)')) {
        var _div = document.createElement('div');

        _div.style.paddingTop = 'env(safe-area-inset-top)';
        document.body.appendChild(_div);

        var _calculatedPadding = (0, _parseInt2["default"])(window.getComputedStyle(_div).paddingTop, 10);

        document.body.removeChild(_div);

        var _valueToReturn = _cssConstants["default"].safeAreaTopDivisor ? _calculatedPadding / _cssConstants["default"].safeAreaTopDivisor : _calculatedPadding;

        return _valueToReturn;
      }
    });
    (0, _defineProperty3["default"])((0, _assertThisInitialized2["default"])(_this), "openTileWithoutAnimation", /*#__PURE__*/(0, _asyncToGenerator2["default"])( /*#__PURE__*/_regenerator["default"].mark(function _callee6() {
      var forceOpen,
          content,
          domId,
          failedPrecondition,
          openOnFail,
          ids,
          id,
          _content,
          path,
          stringPath,
          prevUrl,
          scrollElement,
          el,
          elRect,
          insetTop,
          offset,
          stateToSet,
          _args6 = arguments;

      return _regenerator["default"].wrap(function _callee6$(_context6) {
        while (1) {
          switch (_context6.prev = _context6.next) {
            case 0:
              forceOpen = _args6.length > 0 && _args6[0] !== undefined ? _args6[0] : false;
              content = _this.state.animatedContent;
              domId = _this.state.animatedDomId;

              if (!(!content || !domId)) {
                _context6.next = 5;
                break;
              }

              return _context6.abrupt("return");

            case 5:
              if (forceOpen) {
                _context6.next = 12;
                break;
              }

              failedPrecondition = (0, _PreconditionChecker.getFailingPrecondition)(content.openPrecondition);
              openOnFail = (0, _PreconditionChecker.continueIfPreconditionFailed)(failedPrecondition);

              if (!failedPrecondition) {
                _context6.next = 12;
                break;
              }

              (0, _PreconditionActionExecutioner.preconditionAction)(failedPrecondition, function () {
                return _this.openTileWithoutAnimation(openOnFail);
              });

              if (!openOnFail) {
                _this.setState({
                  tileToOpen: null,
                  animatedContent: null,
                  animatedDomId: null
                });
              }

              return _context6.abrupt("return");

            case 12:
              if (!content.externalURL) {
                _context6.next = 31;
                break;
              }

              if (!(_config["default"].replaceDrupalLinks && content.externalURL.indexOf('drupalid') !== -1)) {
                _context6.next = 28;
                break;
              }

              ids = content.externalURL.split(':');
              id = ids[ids.length - 1];

              if (!id) {
                _context6.next = 26;
                break;
              }

              _content = _KESI2Helper["default"].getContentById(id);
              path = _KESI2Helper["default"].getPathToContentInTree(id);

              if (!(_content && path)) {
                _context6.next = 26;
                break;
              }

              if (path.length > 1 && _content.type === 'nugget') {
                // Remove the last element if it was a nugget, cant link to nuggets right now
                (0, _ArrayHelper.removeElementAtPosition)(path, path.length - 1);
              }

              stringPath = "".concat(_config["default"].baseRoute, "/").concat(path.join('!'));
              prevUrl = "".concat(_config["default"].baseRoute, "/").concat(_this.props.contentPathArray.join(_KesiConstants.KESI_PATH_DELIMITER));
              window.goToKesiUrl(stringPath ? stringPath : _config["default"].cordovaStartUrl(), prevUrl);

              _this.setState({
                tileToOpen: null,
                animatedContent: null,
                animatedDomId: null
              });

              return _context6.abrupt("return");

            case 26:
              _context6.next = 31;
              break;

            case 28:
              window.open(content.externalURL, '_system');

              _this.setState({
                tileToOpen: null,
                animatedContent: null,
                animatedDomId: null
              });

              return _context6.abrupt("return");

            case 31:
              // const newPath = [...this.props.contentPathArray, content.id]
              // NavigationManagerCordova.goTo(`kesi2/${newPath.join(KESI_PATH_DELIMITER)}`)
              // opening tile
              scrollElement = document.getElementById(_this.getFrameElementId());

              if (scrollElement) {
                _this.frameScrollTop = scrollElement.scrollTop;
              }

              _this.setState({
                animatedTile: content.id,
                openTileDomId: domId,
                navigationAllowed: false
              });

              el = document.getElementById(domId);

              if (el) {
                _context6.next = 38;
                break;
              }

              console.error("requested document element with id ".concat(domId, " doesn't exist. Abort opening"));
              return _context6.abrupt("return");

            case 38:
              elRect = el.getBoundingClientRect();

              _this.setState({
                oldWidth: el.offsetWidth,
                oldHeight: el.offsetHeight,
                showOverlay: true,
                openTilePosBeforeOpening: {
                  left: elRect.left,
                  top: elRect.top
                }
              });

              insetTop = _DeviceInfoHelper["default"].isiOS() ? _this.getInsetTop() : 0; // el.style.borderRadius = targetCSS.tiles && targetCSS.tiles.borderRadius ? targetCSS.tiles.borderRadius : '5px'

              setTimeout(function () {
                var overlay = document.getElementById('overlay');

                if (overlay) {
                  overlay.style.opacity = 0.5;
                }
              }, 0);
              el.parentElement.style.zIndex = 100;
              el.style.position = 'absolute';
              el.style.overflow = 'auto';

              if (_DeviceInfoHelper["default"].isiOS() || _DeviceInfoHelper["default"].isBrowser()) {
                _this.setState({
                  expandedTile: content.id
                });
              }

              offset = _this.getViewOffsetAndSize();
              el.style.width = "".concat(offset.width, "px");
              el.style.height = "".concat(offset.height + 2, "px");

              if (elRect.top < _cssConstants["default"].navBarHeight) {
                el.style.transform = "translate3d(-".concat(elRect.left, "px, ").concat(_cssConstants["default"].navBarHeight - elRect.top - insetTop, "px, 0)");
              } else {
                el.style.transform = "translate3d(-".concat(elRect.left, "px, -").concat(Math.max(elRect.top - insetTop, _cssConstants["default"].navBarHeight) - _cssConstants["default"].navBarHeight, "px, 0)");
              }

              stateToSet = {
                navigationAllowed: true
              };

              if (_DeviceInfoHelper["default"].isAndroid()) {
                stateToSet.expandedTile = content.id;
              }

              if (el) {
                el.classList.add(_ErvNestedTiles["default"].tileOpen);
                el.classList.remove(_ErvNestedTiles["default"].open);
                el.classList.remove(_ErvNestedTiles["default"].move);
              }

              stateToSet.overflowYHidden = true;

              _this.setState(stateToSet);

            case 55:
            case "end":
              return _context6.stop();
          }
        }
      }, _callee6);
    })));
    (0, _defineProperty3["default"])((0, _assertThisInitialized2["default"])(_this), "openTile", /*#__PURE__*/(0, _asyncToGenerator2["default"])( /*#__PURE__*/_regenerator["default"].mark(function _callee9() {
      var forceOpen,
          content,
          domId,
          failedPrecondition,
          openOnFail,
          ids,
          _id,
          _content2,
          path,
          stringPath,
          prevUrl,
          scrollElement,
          el,
          elRect,
          insetTop,
          offset,
          id,
          spocContent,
          setArrowContainer,
          bottomBar,
          rippleEffect,
          stateToSet,
          _args9 = arguments;

      return _regenerator["default"].wrap(function _callee9$(_context9) {
        while (1) {
          switch (_context9.prev = _context9.next) {
            case 0:
              forceOpen = _args9.length > 0 && _args9[0] !== undefined ? _args9[0] : false;
              content = _this.state.animatedContent;
              domId = _this.state.animatedDomId;

              if (!(!content || !domId)) {
                _context9.next = 5;
                break;
              }

              return _context9.abrupt("return");

            case 5:
              if (forceOpen) {
                _context9.next = 12;
                break;
              }

              failedPrecondition = (0, _PreconditionChecker.getFailingPrecondition)(content.openPrecondition);
              openOnFail = (0, _PreconditionChecker.continueIfPreconditionFailed)(failedPrecondition);

              if (!failedPrecondition) {
                _context9.next = 12;
                break;
              }

              (0, _PreconditionActionExecutioner.preconditionAction)(failedPrecondition, function () {
                return _this.openTile(openOnFail);
              });

              if (!openOnFail) {
                _this.setState({
                  tileToOpen: null,
                  animatedContent: null,
                  animatedDomId: null
                });
              }

              return _context9.abrupt("return");

            case 12:
              if (!content.externalURL) {
                _context9.next = 31;
                break;
              }

              if (!(_config["default"].replaceDrupalLinks && content.externalURL.indexOf('drupalid') !== -1)) {
                _context9.next = 28;
                break;
              }

              ids = content.externalURL.split(':');
              _id = ids[ids.length - 1];

              if (!_id) {
                _context9.next = 26;
                break;
              }

              _content2 = _KESI2Helper["default"].getContentById(_id);
              path = _KESI2Helper["default"].getPathToContentInTree(_id);

              if (!(_content2 && path)) {
                _context9.next = 26;
                break;
              }

              if (path.length > 1 && _content2.type === 'nugget') {
                // Remove the last element if it was a nugget, cant link to nuggets right now
                (0, _ArrayHelper.removeElementAtPosition)(path, path.length - 1);
              }

              stringPath = "".concat(_config["default"].baseRoute, "/").concat(path.join('!'));
              prevUrl = "".concat(_config["default"].baseRoute, "/").concat(_this.props.contentPathArray.join(_KesiConstants.KESI_PATH_DELIMITER));
              window.goToKesiUrl(stringPath ? stringPath : _config["default"].cordovaStartUrl(), prevUrl);

              _this.setState({
                tileToOpen: null,
                animatedContent: null,
                animatedDomId: null
              });

              return _context9.abrupt("return");

            case 26:
              _context9.next = 31;
              break;

            case 28:
              window.open(content.externalURL, '_system');

              _this.setState({
                tileToOpen: null,
                animatedContent: null,
                animatedDomId: null
              });

              return _context9.abrupt("return");

            case 31:
              // opening tile
              scrollElement = document.getElementById(_this.getFrameElementId());

              if (scrollElement) {
                _this.frameScrollTop = scrollElement.scrollTop;
              }

              _this.setState({
                animatedTile: content.id,
                openTileDomId: domId,
                navigationAllowed: false
              });

              el = document.getElementById(domId);

              if (el) {
                _context9.next = 38;
                break;
              }

              console.error("requested document element with id ".concat(domId, " doesn't exist. Abort opening"));
              return _context9.abrupt("return");

            case 38:
              console.log('openTile1');
              elRect = el.getBoundingClientRect();
              insetTop = _DeviceInfoHelper["default"].isiOS() ? _this.getInsetTop() : 0;
              el.classList.remove(_config["default"].useSimpleTileAnimation ? _ErvNestedTiles["default"].closeFast : _ErvNestedTiles["default"].close);
              el.classList.add(_config["default"].useSimpleTileAnimation ? _ErvNestedTiles["default"].openFast : _ErvNestedTiles["default"].open); // el.style.borderRadius = targetCSS.tiles && targetCSS.tiles.borderRadius ? targetCSS.tiles.borderRadius : '5px'

              _this.setState({
                openTileBorderRadius: {
                  topLeft: el.style.borderTopLeftRadius,
                  topRight: el.style.borderTopRightRadius,
                  bottomLeft: el.style.borderBottomLeftRadius,
                  bottomRight: el.style.borderBottomRightRadius
                },
                oldWidth: el.offsetWidth,
                oldHeight: el.offsetHeight,
                showOverlay: true,
                openTilePosBeforeOpening: {
                  left: elRect.left,
                  top: elRect.top
                }
              });

              setTimeout(function () {
                var overlay = document.getElementById('overlay');

                if (overlay) {
                  overlay.style.opacity = 0.5;
                }
              }, 0);
              el.parentElement.style.zIndex = 100;
              el.style.position = 'absolute';
              offset = _this.getViewOffsetAndSize();
              id = _KESI2Helper["default"].getLastSpocOrCourseId(_this.props.contentPathArray);
              spocContent = _KESI2Helper["default"].getContentById(id);
              el.style.width = "".concat(_config["default"].showProgressBarNextToTiles && spocContent && spocContent.showProgressBar ? offset.width + 50 : offset.width, "px");
              el.style.removeProperty('border-top-left-radius');
              el.style.removeProperty('border-top-right-radius');
              el.style.removeProperty('border-bottom-right-radius');
              el.style.removeProperty('border-bottom-left-radius');
              el.style.height = "".concat(offset.height + 2, "px");

              setArrowContainer = /*#__PURE__*/function () {
                var _ref8 = (0, _asyncToGenerator2["default"])( /*#__PURE__*/_regenerator["default"].mark(function _callee7() {
                  var withRetry,
                      _el,
                      arrowEl,
                      _args7 = arguments;

                  return _regenerator["default"].wrap(function _callee7$(_context7) {
                    while (1) {
                      switch (_context7.prev = _context7.next) {
                        case 0:
                          withRetry = _args7.length > 0 && _args7[0] !== undefined ? _args7[0] : false;

                          if (_config["default"].useArrowsInsteadOfButtonsInWizardNugget) {
                            _el = document.getElementById(domId);
                            arrowEl = document.getElementById("".concat(domId, "_arrow"));

                            if (arrowEl && _el) {
                              arrowEl.style.transform = _el.style.transform; // arrowEl.style.transform = `translate3d(-${elRectForArrows.left}px, -${
                              //   Math.max(elRectForArrows.top - insetTop, targetCSS.navBarHeight) -
                              //   targetCSS.navBarHeight
                              // }px, 0)`
                            }
                          }

                          if (!withRetry) {
                            _context7.next = 6;
                            break;
                          }

                          _context7.next = 5;
                          return (0, _TimeoutHelper.timeout)(1000);

                        case 5:
                          setArrowContainer();

                        case 6:
                        case "end":
                          return _context7.stop();
                      }
                    }
                  }, _callee7);
                }));

                return function setArrowContainer() {
                  return _ref8.apply(this, arguments);
                };
              }();

              if (!_config["default"].useSimpleTileAnimation) {
                _context9.next = 64;
                break;
              }

              if (_config["default"].openTilesInFullScreen) {
                bottomBar = document.getElementById('bottomBar');

                if (bottomBar) {
                  bottomBar.style.opacity = 0;
                  bottomBar.style.zIndex = -1;
                }

                el.style.transform = "translate3d(-".concat(elRect.left, "px, -").concat(Math.max(elRect.top - insetTop, _cssConstants["default"].navBarHeight) - _cssConstants["default"].navBarHeight + 2, "px, 0)");
              } else {
                if (elRect.top < _cssConstants["default"].navBarHeight) {
                  el.style.transform = "translate3d(-".concat(elRect.left, "px, ").concat(_cssConstants["default"].navBarHeight - elRect.top - insetTop, "px, 0)");
                } else {
                  el.style.transform = "translate3d(-".concat(elRect.left, "px, -").concat(Math.max(elRect.top - insetTop, _cssConstants["default"].navBarHeight) - _cssConstants["default"].navBarHeight, "px, 0)");
                }
              }

              _context9.next = 61;
              return (0, _TimeoutHelper.timeout)(1500);

            case 61:
              if (_DeviceInfoHelper["default"].isiOS() || _DeviceInfoHelper["default"].isBrowser()) {
                _this.setState({
                  expandedTile: content.id
                }, function () {
                  setArrowContainer(true);
                });

                _this.onLectureScroll();
              }

              _context9.next = 76;
              break;

            case 64:
              if (elRect.top < _cssConstants["default"].navBarHeight) {
                el.style.transform = "translate3d(-".concat(elRect.left, "px, ").concat(_cssConstants["default"].navBarHeight - 10 - elRect.top - insetTop, "px, 0)");
              } else {
                el.style.transform = "translate3d(-".concat(elRect.left, "px, -").concat(elRect.top - insetTop - (_cssConstants["default"].navBarHeight - 10), "px, 0)");
              }

              rippleEffect = /*#__PURE__*/function () {
                var _ref9 = (0, _asyncToGenerator2["default"])( /*#__PURE__*/_regenerator["default"].mark(function _callee8() {
                  var openingTile, rippleNew;
                  return _regenerator["default"].wrap(function _callee8$(_context8) {
                    while (1) {
                      switch (_context8.prev = _context8.next) {
                        case 0:
                          openingTile = el;

                          if (el) {
                            _context8.next = 5;
                            break;
                          }

                          _context8.next = 4;
                          return (0, _TimeoutHelper.timeout)(50);

                        case 4:
                          return _context8.abrupt("return", rippleEffect());

                        case 5:
                          // Add the element
                          rippleNew = document.createElement('SPAN');
                          rippleNew.classList.add(_ErvNestedTiles["default"].ripple);
                          openingTile.appendChild(rippleNew);
                          rippleNew.classList.add(_ErvNestedTiles["default"].rippleEffect);

                        case 9:
                        case "end":
                          return _context8.stop();
                      }
                    }
                  }, _callee8);
                }));

                return function rippleEffect() {
                  return _ref9.apply(this, arguments);
                };
              }(); // await rippleEffect()


              _context9.next = 68;
              return (0, _TimeoutHelper.timeout)(500);

            case 68:
              if (_DeviceInfoHelper["default"].isiOS() || _DeviceInfoHelper["default"].isBrowser()) {
                _this.setState({
                  expandedTile: content.id
                });
              }

              _context9.next = 71;
              return (0, _TimeoutHelper.timeout)(300);

            case 71:
              el.classList.add(_ErvNestedTiles["default"].move);

              if (elRect.top < _cssConstants["default"].navBarHeight) {
                el.style.transform = "translate3d(-".concat(elRect.left, "px, ").concat(_cssConstants["default"].navBarHeight + 4 - elRect.top - insetTop, "px, 0)");
              } else {
                el.style.transform = "translate3d(-".concat(elRect.left, "px, -").concat(Math.max(elRect.top - insetTop, _cssConstants["default"].navBarHeight) - (_cssConstants["default"].navBarHeight + 4), "px, 0)");
              }

              _context9.next = 75;
              return (0, _TimeoutHelper.timeout)(200);

            case 75:
              if (elRect.top < _cssConstants["default"].navBarHeight) {
                el.style.transform = "translate3d(-".concat(elRect.left, "px, ").concat(_cssConstants["default"].navBarHeight - elRect.top - insetTop, "px, 0)");
              } else {
                el.style.transform = "translate3d(-".concat(elRect.left, "px, -").concat(Math.max(elRect.top - insetTop, _cssConstants["default"].navBarHeight) - _cssConstants["default"].navBarHeight, "px, 0)");
              }

            case 76:
              stateToSet = {
                navigationAllowed: true
              };

              if (el) {
                el.classList.add(_ErvNestedTiles["default"].tileOpen);
                el.classList.remove(_ErvNestedTiles["default"].open);
                el.classList.remove(_ErvNestedTiles["default"].move);
              }

              if (_DeviceInfoHelper["default"].isAndroid()) {
                _this.setState({
                  expandedTile: content.id
                }, function () {
                  setArrowContainer(true);
                });

                _this.onLectureScroll();
              }

              stateToSet.overflowYHidden = true;

              _this.setState(stateToSet);

            case 81:
            case "end":
              return _context9.stop();
          }
        }
      }, _callee9);
    })));
    (0, _defineProperty3["default"])((0, _assertThisInitialized2["default"])(_this), "openExternalPage", function (url, content) {
      (0, _LogService["default"])(content.id, _this.props.contentPathArray.join(_KesiConstants.KESI_PATH_DELIMITER), {
        url: url
      });
      window.open(url, '_system');
    });
    (0, _defineProperty3["default"])((0, _assertThisInitialized2["default"])(_this), "getBulkTileDataFromFlexMenu", /*#__PURE__*/function () {
      var _ref10 = (0, _asyncToGenerator2["default"])( /*#__PURE__*/_regenerator["default"].mark(function _callee10(pathArray, homeRegionCode) {
        var homeRegion, tileData, tiles, _iterator, _step, tile;

        return _regenerator["default"].wrap(function _callee10$(_context10) {
          while (1) {
            switch (_context10.prev = _context10.next) {
              case 0:
                homeRegion = _config["default"].tcCountryHelper.getRegionNameByCode(homeRegionCode);
                tileData = (0, _assign["default"])({}, _this.state.tileData);
                tiles = _this.state.sortedElements;
                _iterator = _createForOfIteratorHelper(tiles);

                try {
                  for (_iterator.s(); !(_step = _iterator.n()).done;) {
                    tile = _step.value;
                    tileData[tile.id] = (0, _FlexMenuHelper.getFlexMenuData)([].concat((0, _toConsumableArray2["default"])(pathArray), [tile.id]), homeRegion);
                  }
                } catch (err) {
                  _iterator.e(err);
                } finally {
                  _iterator.f();
                }

                _this.setState({
                  tileData: tileData
                });

              case 6:
              case "end":
                return _context10.stop();
            }
          }
        }, _callee10);
      }));

      return function (_x5, _x6) {
        return _ref10.apply(this, arguments);
      };
    }());
    (0, _defineProperty3["default"])((0, _assertThisInitialized2["default"])(_this), "goToNextPage", function (type) {
      var newPage = _this.state.pageIndex + 1;
      (0, _LogService.pushTravelAndCareLogMessage)('security_profile', {
        region: _this.state.regionCode
      });

      _this.setState({
        pageIndex: newPage,
        ervPageType: type || ERV_PAGE_TYPES.SEC_PROFILE
      });

      _this.props.setBackButtonFunc(_this.goBack);
    });
    (0, _defineProperty3["default"])((0, _assertThisInitialized2["default"])(_this), "goBack", function () {
      var newPage = _this.state.pageIndex - 1;

      _this.setState({
        pageIndex: newPage
      });

      if (newPage === 0 && _this.props.isFirstLayer) {
        _this.props.setBackButtonFunc(null);
      }
    });
    (0, _defineProperty3["default"])((0, _assertThisInitialized2["default"])(_this), "setRegionCode", function (regionCode, index) {
      _this.setState({
        regionCode: regionCode,
        index: index
      });
    });
    (0, _defineProperty3["default"])((0, _assertThisInitialized2["default"])(_this), "onLectureScroll", function () {
      var element = _this.refScroll.current;

      if (element) {
        if (element.offsetHeight === element.scrollHeight && !_this.scrollIndicatorHidden) {
          _this.scrollIndicatorHidden = true;
          return;
        }

        if (element.offsetHeight + element.scrollTop + 40 < element.scrollHeight && !_this.scrollIndicatorHidden) {
          setTimeout(function () {
            _this.setState({
              scrollIndicatorHidden: false
            });
          }, 100);
        } else if (element.offsetHeight + element.scrollTop + 20 >= element.scrollHeight && !_this.scrollIndicatorHidden) {
          _this.scrollIndicatorHidden = true;
          setTimeout(function () {
            _this.setState({
              scrollIndicatorHidden: true
            });
          }, 100);
        }
      }
    });
    (0, _defineProperty3["default"])((0, _assertThisInitialized2["default"])(_this), "onScroll", function () {
      if (!_this.state.overflowYHidden) {
        if (_this.state.animatedTile || _this.state.expandedTile) {
          if (_this.frameScrollTop !== null) {
            var scrollElement = document.getElementById(_this.getFrameElementId());

            if (scrollElement) {
              scrollElement.scrollTop = _this.frameScrollTop;
              setTimeout(function () {
                scrollElement.scrollTop = _this.frameScrollTop;
              }, 50);
            }
          }

          if (!_this.isSettingOverflowYHidden) {
            _this.isSettingOverflowYHidden = true;

            _this.setState({
              overflowYHidden: true
            }, function () {
              _this.isSettingOverflowYHidden = false;
            });
          }
        }
      }
    });
    (0, _defineProperty3["default"])((0, _assertThisInitialized2["default"])(_this), "getContentGroups", function () {
      var groups = {};

      _this.state.sortedElements.forEach(function (content) {
        var failingPrecondition = (0, _PreconditionChecker.getFailingPrecondition)(content.showPrecondition);

        if (content && content.keyword && !failingPrecondition) {
          if (groups[content.keyword]) {
            groups[content.keyword].push(content.id);
          } else {
            groups[content.keyword] = [content.id];
          }
        }
      });

      return groups;
    });
    (0, _defineProperty3["default"])((0, _assertThisInitialized2["default"])(_this), "getShowDateFromPrecondition", function (content) {
      var preconditionObj = content.showPrecondition;
      var dateString = null;
      var isToday = false;
      var daysIn = null;

      if (preconditionObj && preconditionObj.conditions) {
        preconditionObj.conditions.forEach(function (conditionBlock) {
          conditionBlock.forEach(function (singleCondition) {
            var conditionParts = singleCondition.split(' ');

            if (conditionParts && conditionParts.length > 1 && conditionParts[1] === 'daysAfterStartDateAtTime') {
              daysIn = (0, _parseInt2["default"])(conditionParts[0]);
              var startDate = _DataStore["default"].getElementByPathImmediately(_DataStore.DATA_STORE_PATHS.SCHICHTBOX_START_DATE) || '';
              var date = new Date(startDate);
              date.setDate(date.getDate() + daysIn);
              var today = new Date();
              isToday = date.getDate() === today.getDate() && date.getMonth() === today.getMonth() && date.getFullYear() === today.getFullYear();
              var options = {
                year: 'numeric',
                month: 'long',
                day: 'numeric'
              };
              dateString = date.toLocaleDateString('de', options);
            }
          });
        });
      }

      return {
        string: dateString,
        isToday: isToday,
        day: daysIn
      } || false;
    });
    (0, _defineProperty3["default"])((0, _assertThisInitialized2["default"])(_this), "setWizardArrowFns", function (type, Fn) {
      console.log('setWizardArrowFns', type, Fn);

      if (type === WIZARD_FN_TYPES.NEXT && Fn !== _this.state.wizardNuggetNextFn) {
        console.log('really setWizardArrowFns', type, Fn);

        _this.setState({
          wizardNuggetNextFn: Fn
        });
      } else if (type === WIZARD_FN_TYPES.BACK && Fn !== _this.state.wizardNuggetBackFn) {
        _this.setState({
          wizardNuggetBackFn: Fn
        });
      } else {
        _this.setState({
          wizardNuggetCloseFn: Fn
        });
      }
    });
    (0, _defineProperty3["default"])((0, _assertThisInitialized2["default"])(_this), "showNextWizardPage", /*#__PURE__*/function () {
      var _ref11 = (0, _asyncToGenerator2["default"])( /*#__PURE__*/_regenerator["default"].mark(function _callee11(goBack) {
        return _regenerator["default"].wrap(function _callee11$(_context11) {
          while (1) {
            switch (_context11.prev = _context11.next) {
              case 0:
                _this.resetScrollIndicator();

                if (goBack) {
                  if (_this.state.wizardNuggetBackFn) {
                    _this.state.wizardNuggetBackFn();
                  }
                } else {
                  if (_this.state.wizardNuggetNextFn) {
                    _this.state.wizardNuggetNextFn();
                  }
                }

              case 2:
              case "end":
                return _context11.stop();
            }
          }
        }, _callee11);
      }));

      return function (_x7) {
        return _ref11.apply(this, arguments);
      };
    }());
    (0, _defineProperty3["default"])((0, _assertThisInitialized2["default"])(_this), "resetScrollIndicator", /*#__PURE__*/(0, _asyncToGenerator2["default"])( /*#__PURE__*/_regenerator["default"].mark(function _callee12() {
      return _regenerator["default"].wrap(function _callee12$(_context12) {
        while (1) {
          switch (_context12.prev = _context12.next) {
            case 0:
              _this.setState({
                scrollIndicatorHidden: true
              });

              _this.scrollIndicatorHidden = false;
              _context12.next = 4;
              return (0, _TimeoutHelper.timeout)(500);

            case 4:
              _this.onLectureScroll();

            case 5:
            case "end":
              return _context12.stop();
          }
        }
      }, _callee12);
    })));
    (0, _defineProperty3["default"])((0, _assertThisInitialized2["default"])(_this), "closeWizard", function () {
      _this.state.wizardNuggetCloseFn();
    });
    _this.state = _objectSpread({
      flippingTileAbsolutePos: {
        x: 0,
        y: 0
      },
      isHidden: false,
      currentScrollTop: 0,
      sortedElements: [],
      swipeIndex: 0,
      expandedTile: null,
      animatedTile: null,
      oldWidth: 0,
      oldHeight: 0,
      showOverlay: false,
      openTileDomId: null,
      allRegions: [],
      filteredRegions: [],
      regions: [],
      tileData: {},
      pageIndex: 0,
      regionCode: null,
      index: 0,
      tileClosing: false,
      tileVisibility: {},
      news: [],
      overflowYHidden: false,
      tileOpenedAutomatically: false,
      openTilePosBeforeOpening: null,
      openTileGroup: null,
      openTileBorderRadius: null,
      animatedDemoTileId: null,
      wizardNuggetNextFn: null,
      wizardNuggetBackFn: null,
      wizardNuggetCloseFn: null,
      scrollIndicatorHidden: true,
      ervPageType: ERV_PAGE_TYPES.SEC_PROFILE
    }, _this.state);
    _this.flippingTilePosition = {
      top: 0,
      left: 0
    };
    _this.viewOffsetAndSize = {
      top: 0,
      left: 0,
      width: 0,
      height: 0
    };
    _this.onNextComponentUpdate = null;
    _this.notifyAboutComponentUpdates = true;
    _this.isOpeningTransition = false;
    _this.isClosingTransitionForTile = false;
    _this.allowTransitionForFlippingTile = true;
    _this.scrollPositionOnClose = null;
    _this.isInternetExplorer = _DeviceInfoHelper["default"].isInternetExplorer();
    _this.scrollListener = _this.initScrollListener();
    _this.frameScrollTop = null;
    _this.refScroll = /*#__PURE__*/_react["default"].createRef();
    _this.isSettingOverflowYHidden = false;
    _this.scrollIndicatorHidden = false;
    (0, _get2["default"])((_thisSuper = (0, _assertThisInitialized2["default"])(_this), (0, _getPrototypeOf2["default"])(NonFlippingGenericTiles.prototype)), "setDataStorePaths", _thisSuper).call(_thisSuper, [_DataStore.DATA_STORE_PATHS.TC_HOME_REGION_CODE, _DataStore.DATA_STORE_PATHS.TC_LANGUAGE_CODE, _DataStore.DATA_STORE_PATHS.FILTER_FAVORITES, _DataStore.DATA_STORE_PATHS.KESI_ADDITIONAL_DATA, _DataStore.DATA_STORE_PATHS.KESI_UPDATE_VALUE, _DataStore.DATA_STORE_PATHS.KESI_VISIBILITIES, _DataStore.DATA_STORE_PATHS.TC_USER_ROLE, _DataStore.DATA_STORE_PATHS.TC_POLICY_NUMBER, _DataStore.DATA_STORE_PATHS.ERGO_ACTIVATED, _DataStore.DATA_STORE_PATHS.TC_IS_CUSTOMER_VERSION]);
    return _this;
  }

  (0, _createClass2["default"])(NonFlippingGenericTiles, [{
    key: "componentWillMount",
    value: function componentWillMount() {
      if (_config["default"].isSafetureApp && this.props.contentPathArray && this.props.contentPathArray.length < 2) {
        return;
      }

      var idToUse = _KESI2Helper["default"].getLastSpocOrCourseId(this.props.contentPathArray);

      if (!idToUse) {
        idToUse = _config["default"].rootId;
      }

      if (idToUse) {
        var contentTree = _KESI2Helper["default"].getContentTreeByPath(this.props.contentPathArray.slice(0, this.props.contentPathArray.indexOf(idToUse) + 1));

        var state = {
          contentTree: contentTree
        };
        state.sortedElements = this.initSortedTiles(this.props, contentTree, this.state.relevances);
        this.setState(state);
      }
    }
  }, {
    key: "componentDidMount",
    value: function componentDidMount() {
      _AppCordova["default"].addOnPageScrollListener(this.scrollListener, true);

      document.addEventListener('hideKeyboard', this.checkScrollTop);

      if (_config["default"].usesFlexMenu && _config["default"].tcCountryHelper) {
        var homeRegion = this.state.data[_DataStore.DATA_STORE_PATHS.TC_HOME_REGION_CODE];
        this.getBulkTileDataFromFlexMenu(this.props.contentPathArray, homeRegion);
      }

      var id = _KESI2Helper["default"].getLastSpocOrCourseId(this.props.contentPathArray);

      this.setLectureTitle(id);

      if (_config["default"].useKeywordForContentGroups) {
        var groups = this.getContentGroups();
        this.setState({
          openTileGroup: (0, _keys["default"])(groups)[0]
        });
      }

      this.openTileAccordingToURLAfterDelay(this.props, this.state);
    }
  }, {
    key: "componentDidUpdate",
    value: function componentDidUpdate(prevProps, prevState, snapshot) {
      (0, _get2["default"])((0, _getPrototypeOf2["default"])(NonFlippingGenericTiles.prototype), "componentDidUpdate", this).call(this, prevProps, prevState, snapshot); // if (
      //   prevState.data[DATA_STORE_PATHS.KESI_UPDATE_VALUE] !==
      //   this.state.data[DATA_STORE_PATHS.KESI_UPDATE_VALUE]
      // ) {
      //   const contentTree = KESI2Helper.getContentTreeByPath(
      //     this.props.contentPathArray
      //   )
      //   const sortedElements = this.initSortedTiles(
      //     this.props,
      //     contentTree,
      //     prevState.relevances
      //   )
      //   this.setState({sortedElements: sortedElements})
      // }

      if (_config["default"].isSafetureApp && prevState.data[_DataStore.DATA_STORE_PATHS.TC_POLICY_NUMBER] !== this.state.data[_DataStore.DATA_STORE_PATHS.TC_POLICY_NUMBER] || !_config["default"].isSafetureApp && !_config["default"].isErgoApp) {
        // problem: when a policy is activated in the settings menu and a tile is open, this tile might have a different position afterwards due to now visible/ invisible tiles -> recheck!)
        // not perfect solution -> but dont do it for erv or ergo pro because the tiles might not be at the top of the page because of newsfeed or safety shield
        if (this.state.openTileDomId) {
          var openTile = document.getElementById(this.state.openTileDomId);
          var parentPos = openTile && openTile.parentElement ? openTile.parentElement.getBoundingClientRect() : null;

          if (parentPos) {
            if (this.state.openTilePosBeforeOpening && (parentPos.left !== this.state.openTilePosBeforeOpening.left || parentPos.top !== this.state.openTilePosBeforeOpening.top)) {
              var insetTop = _DeviceInfoHelper["default"].isiOS() ? this.getInsetTop() : 0;

              if (parentPos.top < _cssConstants["default"].navBarHeight) {
                openTile.style.transform = "translate3d(-".concat(parentPos.left, "px, ").concat(_cssConstants["default"].navBarHeight - parentPos.top - insetTop, "px, 0)");
              } else {
                openTile.style.transform = "translate3d(-".concat(parentPos.left, "px, -").concat(parentPos.top - insetTop - _cssConstants["default"].navBarHeight, "px, 0)");
              }
            }
          }
        }
      }

      if (prevProps.contentPathArray !== this.props.contentPathArray) {
        var id = _KESI2Helper["default"].getLastSpocOrCourseId(this.props.contentPathArray);

        this.setLectureTitle(id); // if tab is changed while a tile is open -> hard close it without animating

        if (prevState.openTileDomId) {
          var el = document.getElementById(prevState.openTileDomId);
          var hideTileAnimation = _DataStore["default"].getElementByPathImmediately(_DataStore.DATA_STORE_PATHS.KESI_HIDE_TILE_ANIMATION) || false;

          if (el) {
            el.scrollTop = 0;

            if (!hideTileAnimation) {
              el.classList.remove(_ErvNestedTiles["default"].open);
              el.classList.remove(_ErvNestedTiles["default"].move);
              el.classList.add(_ErvNestedTiles["default"].close);
            }

            el.style.transform = "translate3d(0, 0, 0)";
            el.style.width = "".concat(this.state.oldWidth, "px");
            el.style.removeProperty('height');
            el.style.position = 'relative';
            el.parentElement.style.zIndex = 0;
          }
        }

        var idToUse = _KESI2Helper["default"].getLastSpocOrCourseId(this.props.contentPathArray);

        if (idToUse) {
          var contentTree = _KESI2Helper["default"].getContentTreeByPath(this.props.contentPathArray.slice(0, this.props.contentPathArray.indexOf(idToUse) + 1));

          var state = {
            contentTree: contentTree,
            animatedTile: null,
            expandedTile: null,
            openTileDomId: null,
            showOverlay: false
          };
          state.sortedElements = this.initSortedTiles(this.props, contentTree, prevState.relevances);
          this.setState(state);
        }
      }

      if (_config["default"].usesFlexMenu && _config["default"].tcCountryHelper) {
        var oldHomeRegion = prevState.data[_DataStore.DATA_STORE_PATHS.TC_HOME_REGION_CODE];
        var newHomeRegion = this.state.data[_DataStore.DATA_STORE_PATHS.TC_HOME_REGION_CODE];

        if (oldHomeRegion !== newHomeRegion) {
          this.getBulkTileDataFromFlexMenu(this.props.contentPathArray, newHomeRegion);
        }
      }

      var oldLang = prevState.data[_DataStore.DATA_STORE_PATHS.TC_LANGUAGE_CODE];
      var newLang = this.state.data[_DataStore.DATA_STORE_PATHS.TC_LANGUAGE_CODE];

      if (oldLang !== newLang) {
        var _id2 = _KESI2Helper["default"].getLastSpocOrCourseId(this.props.contentPathArray);

        this.setLectureTitle(_id2);
      }

      if ((0, _ArrayHelper.getLastElement)(this.props.contentPathArray) !== (0, _ArrayHelper.getLastElement)(prevProps.contentPathArray)) {
        this.openTileAccordingToURLAfterDelay(this.props, this.state);
      }

      if (prevState.expandedTile && !this.state.expandedTile) {
        console.log('NonFlippingGenericTile tile was closed');
        this.setState({
          wizardNuggetNextFn: null,
          wizardNuggetBackFn: null,
          wizardNuggetCloseFn: null,
          scrollIndicatorHidden: true
        });
        this.closingTile();
      }
    }
  }, {
    key: "componentWillUnmount",
    value: function componentWillUnmount() {
      (0, _get2["default"])((0, _getPrototypeOf2["default"])(NonFlippingGenericTiles.prototype), "componentWillUnmount", this).call(this);
      document.removeEventListener('hideKeyboard', this.checkScrollTop);

      _AppCordova["default"].removeOnPageScrollListener(this.scrollListener);
    }
    /****
     This is a fix for Android when the keyboard is closed in an iFrame and the scrollFrame has a scrollTop
     Normally the whole tile will be moved down -> we check when that happens and correct it (resulting in a very minor flicker)
     ****/

  }, {
    key: "openTileAccordingToURLAfterDelay",
    value: function openTileAccordingToURLAfterDelay(props, state) {
      var _this2 = this;

      var delay = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 500;

      // navigate down to element according url
      var idToUse = _KESI2Helper["default"].getLastSpocOrCourseId(props.contentPathArray);

      var lastId = (0, _ArrayHelper.getLastElement)(props.contentPathArray);

      if (lastId !== idToUse) {
        setTimeout(function () {
          var elementToOpen = state.sortedElements.find(function (element) {
            return element.id === lastId;
          });

          if (elementToOpen) {
            _this2.setOpenTile(elementToOpen, false);
          }
        }, delay);
      }
    }
  }, {
    key: "initSortedTiles",
    value: function initSortedTiles(props, contentTree, relevances) {
      var contents = [];
      var type = _Constants.CONTENT_TYPES.COURSE;

      if (_config["default"].usesCourses && _config["default"].showCoursesAsTiles && contentTree && contentTree.courses && contentTree.courses.length > 0) {
        contents.push.apply(contents, (0, _toConsumableArray2["default"])(contentTree.courses));
      }

      if (contentTree && contentTree.spocs && contentTree.spocs.length > 0) {
        type = _Constants.CONTENT_TYPES.SPOC;
        contents.push.apply(contents, (0, _toConsumableArray2["default"])(contentTree.spocs));
      }

      if (contentTree && contentTree.lectures) {
        type = _Constants.CONTENT_TYPES.LECTURE; // contents = contentTree.lectures

        contents.push.apply(contents, (0, _toConsumableArray2["default"])(contentTree.lectures));
      }

      return this.sortElements(props.contentPathArray, contents, relevances, type);
    }
  }, {
    key: "onWindowSizeChanged",
    value: function () {
      var _onWindowSizeChanged = (0, _asyncToGenerator2["default"])( /*#__PURE__*/_regenerator["default"].mark(function _callee13() {
        return _regenerator["default"].wrap(function _callee13$(_context13) {
          while (1) {
            switch (_context13.prev = _context13.next) {
              case 0:
                this.viewOffsetAndSize = this.getViewOffsetAndSize();
                this.allowTransitionForFlippingTile = false;
                this.forceUpdate();
                _context13.next = 5;
                return (0, _TimeoutHelper.timeout)();

              case 5:
                this.allowTransitionForFlippingTile = true;

              case 6:
              case "end":
                return _context13.stop();
            }
          }
        }, _callee13, this);
      }));

      function onWindowSizeChanged() {
        return _onWindowSizeChanged.apply(this, arguments);
      }

      return onWindowSizeChanged;
    }()
  }, {
    key: "getFrameElementId",
    value: function getFrameElementId() {
      return "tiles-frame2-not-background-".concat(_KESI2Helper["default"].getLastSpocOrCourseId(this.props.contentPathArray));
    }
  }, {
    key: "getStyleForTile",
    value: function getStyleForTile(chapter, size, isFirstInGroup, isLastInGroup, isShrinked) {
      var _targetCSS$tiles, _targetCSS$tiles2, _targetCSS$tiles3;

      if (size === 0) {
        return {
          container: {
            display: 'hidden'
          },
          tile: {
            display: 'hidden'
          }
        };
      }

      var id = _KESI2Helper["default"].getLastSpocOrCourseId(this.props.contentPathArray);

      var spocContent = _KESI2Helper["default"].getContentById(id);

      var width = _config["default"].useLandscapeTiles || chapter.keyword === _DrupalNestedTileSizes.LANDSCAPE_FULL ? _config["default"].showProgressBarNextToTiles && spocContent && spocContent.showProgressBar ? 'calc(100% - 115px)' : 'calc(100% - 55px)' : size * this.props.zoomValue;
      var height = size * this.props.zoomValue;
      var margin = _DrupalNestedTileSizes.MARGIN_BETWEEN_TILES * this.props.zoomValue;
      var isVisible = false;

      if (this.props.showOnlyTileWithId && this.props.showOnlyTileWithId === chapter.id) {
        isVisible = true;
      }

      if (!this.props.showOnlyTileWithId && (chapter.id !== this.props.renderChildrenForId || !this.isOpeningTransition && !this.isClosingTransitionForTile)) {
        isVisible = true;
      }

      if (this.props.hideTileForId === chapter.id) {
        isVisible = false;
      }

      var isFavorite = _DataStore["default"].pathExists("".concat(_DataStore.DATA_STORE_PATHS.KESI_ADDITIONAL_DATA, ".").concat(chapter.id, ".favorite")) ? _DataStore["default"].getElementByPathImmediately("".concat(_DataStore.DATA_STORE_PATHS.KESI_ADDITIONAL_DATA, ".").concat(chapter.id, ".favorite")) : false;

      if (!isFavorite && this.state.data[_DataStore.DATA_STORE_PATHS.FILTER_FAVORITES] && (this.props.isFirstLayer && !this.state.expandedTile || !this.props.isFirstLayer)) {
        isVisible = false;
        height = 0;
        width = 0;
        margin = 0;
      }

      this.setTileVisibility(chapter.id, isVisible);
      var tilePath = [].concat((0, _toConsumableArray2["default"])(this.props.contentPathArray), [chapter.id]);
      var visible = _DataStore["default"].pathExists("".concat(_DataStore.DATA_STORE_PATHS.KESI_VISIBILITIES, ".").concat(chapter.id, ".").concat(this.props.contentPathArray.join(_KesiConstants.KESI_PATH_DELIMITER))) ? this.state.data[_DataStore.DATA_STORE_PATHS.KESI_VISIBILITIES][chapter.id][this.props.contentPathArray.join(_KesiConstants.KESI_PATH_DELIMITER)] : null;
      var active = tilePath && visible !== null ? visible : chapter.active;

      if (!_config["default"].isKesiMaster && !_FeatureManager["default"].getFeature(_config["default"].kesiMasterFeatureName)) {
        var masterFeature = _FeatureManager["default"].getFeature(_config["default"].kesiMasterFeatureName);

        if (!active && !masterFeature && !_config["default"].isKesiMaster) {
          isVisible = false;
          height = 0;
          width = 0;
          margin = 0;
        }
      }

      var borderRadius = _cssConstants["default"].tiles && _cssConstants["default"].tiles.borderRadius ? _cssConstants["default"].tiles.borderRadius : '';
      var updatedMargin = margin;
      var cssRadius = _cssConstants["default"].tiles && _cssConstants["default"].tiles.borderRadius ? _cssConstants["default"].tiles.borderRadius : 0;

      if (_config["default"].useKeywordForContentGroups) {
        //borderRadius: topLeft topRight bottomRight bottomLeft
        //margin: top right bottom left
        if (isFirstInGroup && !isLastInGroup) {
          borderRadius = "".concat(cssRadius, " ").concat(cssRadius, " 0 0");
          updatedMargin = "".concat(2 * margin, "px ").concat(margin + 20, "px 3px ").concat(margin + 20, "px");
        } else if (!isFirstInGroup && isLastInGroup) {
          borderRadius = "0 0 ".concat(cssRadius, " ").concat(cssRadius);
          updatedMargin = "3px ".concat(margin + 20, "px ").concat(2 * margin, "px ").concat(margin + 20, "px");
        } else if (!isFirstInGroup && !isLastInGroup) {
          borderRadius = '0px';
          updatedMargin = "3px ".concat(margin + 20, "px 3px ").concat(margin + 20, "px");
        } else {
          // only element -> first and last in group
          borderRadius = cssRadius;
          updatedMargin = "".concat(2 * margin, "px ").concat(margin + 20, "px ").concat(2 * margin, "px ").concat(margin + 20, "px");
        }
      }

      if (isShrinked) {
        height = height / 1.4;
        borderRadius = cssRadius;
      }

      return {
        container: {
          width: width,
          height: height,
          margin: updatedMargin,
          zIndex: Z_INDEX.BACKGROUND,
          opacity: isVisible ? 1 : 0,
          boxShadow: (_cssConstants["default"] === null || _cssConstants["default"] === void 0 ? void 0 : (_targetCSS$tiles = _cssConstants["default"].tiles) === null || _targetCSS$tiles === void 0 ? void 0 : _targetCSS$tiles.boxShadow) ? _cssConstants["default"] === null || _cssConstants["default"] === void 0 ? void 0 : (_targetCSS$tiles2 = _cssConstants["default"].tiles) === null || _targetCSS$tiles2 === void 0 ? void 0 : _targetCSS$tiles2.boxShadow : null,
          borderRadius: borderRadius,
          willChange: 'height, max-height',
          // transition: 'height 500ms',
          transition: 'max-height 2000ms, height 500ms',
          maxHeight: this.state.animatedDemoTileId === chapter.id ? 0 : 2000
        },
        tile: {
          borderRadius: borderRadius,
          border: (_cssConstants["default"] === null || _cssConstants["default"] === void 0 ? void 0 : (_targetCSS$tiles3 = _cssConstants["default"].tiles) === null || _targetCSS$tiles3 === void 0 ? void 0 : _targetCSS$tiles3.border) || 'none',
          overflow: 'hidden'
        }
      };
    }
  }, {
    key: "sortElements",
    value: function sortElements(parentPath, contents, relevances, type) {
      if (_config["default"].sortAlphabetically) {
        return contents.sort(function (content1, content2) {
          if (content1.title < content2.title) {
            return -1;
          }

          if (content1.title > content2.title) {
            return 1;
          }

          return 0;
        });
      }

      if (_config["default"].sortById) {
        return contents.sort(function (content1, content2) {
          return content1.id - content2.id;
        });
      }

      if (_config["default"].sortByOrderField && (type === _Constants.CONTENT_TYPES.SPOC || type === _Constants.CONTENT_TYPES.LECTURE || type === _Constants.CONTENT_TYPES.COURSE)) {
        return contents.sort(function (content1, content2) {
          if ((content1.order || content1.order === 0) && (content2.order || content2.order === 0)) {
            if (content1.order < content2.order) {
              return -1;
            }

            if (content1.order > content2.order) {
              return 1;
            }

            return 0;
          } else {
            // Don't bring up id sorting here!
            // This piece of code is used for lecture-in-spoc sorting, too and we want to keep the author's order there
            return 0;
          }
        });
      } // check if there are really relevances in there or if it is just an empty object


      if ((0, _keys["default"])(relevances).length === 0) {
        return contents;
      }

      return contents.map(function (content) {
        return {
          content: content,
          relevance: relevances[[].concat((0, _toConsumableArray2["default"])(parentPath), [content.id]).join(_KesiConstants.KESI_PATH_DELIMITER)]
        };
      }).sort(function (element1, element2) {
        if (element1.relevance > element2.relevance) {
          return -1;
        }

        if (element1.relevance < element2.relevance) {
          return 1;
        }

        return 0;
      }).map(function (element) {
        return element.content;
      });
    }
  }, {
    key: "getTileIdForContent",
    value: function getTileIdForContent(contentId) {
      return "tile-".concat(contentId).concat(this.props.fadeOut ? '_fadeout' : '');
    }
  }, {
    key: "getTileSize",
    value: function getTileSize(parentPath, contentId) {
      var relevance = _RelevancesService.DEFAULT_RELEVANCE;

      if (this.state.relevances) {
        relevance = this.state.relevances[[].concat((0, _toConsumableArray2["default"])(parentPath), [contentId]).join(_KesiConstants.KESI_PATH_DELIMITER)] || this.state.relevances._default || _RelevancesService.DEFAULT_RELEVANCE;
      }

      if (relevance > 66 && relevance <= 100) {
        return _DrupalNestedTileSizes.TILE_SIZES.LARGE;
      }

      if (relevance > 33) {
        return _DrupalNestedTileSizes.TILE_SIZES.MEDIUM;
      }

      if (relevance >= 0) {
        return _DrupalNestedTileSizes.TILE_SIZES.SMALL;
      }

      if (relevance === -1) {
        return _DrupalNestedTileSizes.TILE_SIZES.INVISIBLE;
      }

      return _DrupalNestedTileSizes.TILE_SIZES.INVISIBLE;
    }
  }, {
    key: "getViewOffsetAndSize",
    value: function getViewOffsetAndSize() {
      var width = 0;
      var height = 0;
      var top = 0;
      var left = 0;
      var frameElement = document.getElementById(this.getFrameElementId());

      if (frameElement) {
        if (frameElement.offsetTop) {
          top = frameElement.offsetTop;
        } else {
          // find parent with top offset
          var _parent = frameElement.parentNode;

          while (_parent) {
            if (_parent.offsetTop) {
              top = _parent.offsetTop;
              break;
            }

            if (!_parent.parentNode) {
              break;
            }

            _parent = _parent.parentNode;
          }

          if (!top) {
            console.warn("no offset top for element with id ".concat(this.getFrameElementId(), " or any parent -- is there no nav bar?"));
          }
        }

        if (frameElement.offsetLeft) {
          left = frameElement.offsetLeft;
        }

        if (frameElement.offsetWidth > 0) {
          width = frameElement.offsetWidth;
        }

        if (frameElement.offsetHeight > 0) {
          height = frameElement.offsetHeight;
        }

        var parent = frameElement.parentNode;

        while (parent) {
          if (!width && parent.offsetWidth > 0) {
            width = parent.offsetWidth;
          }

          if (!height && parent.offsetHeight > 0) {
            height = parent.offsetHeight;
          }

          if (width && height) {
            break;
          }

          parent = parent.parentNode;
        }
      }

      if (!this.props.isRoot) {
        top = 0;
      }

      console.log('viewandoffsetsize', height);
      return {
        top: top,
        left: left,
        width: width,
        height: height
      };
    }
  }, {
    key: "initScrollListener",
    value: function initScrollListener() {
      var _this3 = this;

      return function (scrollTop) {
        _this3.setState({
          currentScrollTop: scrollTop
        });
      };
    }
  }, {
    key: "renderGoUpButton",
    value: function renderGoUpButton() {
      if (!this.props.showGoUpButton) {
        return null;
      }

      return /*#__PURE__*/_react["default"].createElement("div", {
        className: "".concat(_ErvNestedTiles["default"].tilesButtonsClose, " ").concat(this.props.showGoUpButton ? '' : _ErvNestedTiles["default"].hiddenByOpacity)
      }, /*#__PURE__*/_react["default"].createElement("span", {
        onClick: this.props.goUpFunc,
        className: _ErvNestedTiles["default"].closeButton
      }, /*#__PURE__*/_react["default"].createElement(_reactFontawesome["default"], {
        name: "times"
      })));
    }
  }, {
    key: "tileCantBeOpened",
    value: function tileCantBeOpened(content, animated, expanded) {
      return expanded || animated;
    }
  }, {
    key: "isRegionAvailable",
    value: function isRegionAvailable(content) {
      return false;
    }
  }, {
    key: "renderTile",
    value: function renderTile(content) {
      var _this4 = this;

      var forcedSize = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : null;

      if ((0, _PreconditionChecker.getFailingPrecondition)(content.showPrecondition)) {
        return null;
      }

      var isAuthor = _DataStore["default"].getElementByPathImmediately(_DataStore.DATA_STORE_PATHS.KESI_SHOW_UNPUBLISHED_CONTENT);

      if (_config["default"].showOnlyPublishedContent && !isAuthor && !content.isPublished) {
        return null;
      }

      var isCustomerVersion = _config["default"].isSafetureApp ? _DataStore["default"].getElementByPathImmediately(_DataStore.DATA_STORE_PATHS.TC_IS_CUSTOMER_VERSION) || false : false;

      if (isCustomerVersion) {
        var tileData = this.state.tileData[content.id];
        console.log('tileData', tileData, content.id);

        if (tileData && tileData.isVisibleForCustomers === false && content.id !== '297' && content.id !== '298') {
          return null;
        }
      }

      var contentGroups = [];
      var groupIndex = 0;
      var isFirstInGroup;
      var isLastInGroup;
      var isShrinked = false;
      var isHiddenByShrink = false;

      if (_config["default"].useKeywordForContentGroups) {
        contentGroups = this.getContentGroups();

        if (contentGroups && contentGroups[content.keyword]) {
          groupIndex = contentGroups[content.keyword].indexOf(content.id);
          isFirstInGroup = _config["default"].useKeywordForContentGroups && groupIndex === 0;
          isLastInGroup = _config["default"].useKeywordForContentGroups && contentGroups[content.keyword] && groupIndex === contentGroups[content.keyword].length - 1;

          if (this.state.openTileGroup !== content.keyword && _config["default"].shrinkTileGroups) {
            if (isFirstInGroup) isShrinked = true;else isHiddenByShrink = true;
          }
        }
      }

      var size = forcedSize || this.getTileSize(this.props.contentPathArray, content.id);
      var style = this.getStyleForTile(content, size, isFirstInGroup, isLastInGroup, isShrinked);

      if (isHiddenByShrink) {
        style.container.height = 0;
      }

      var extraClassName = content.unhighlightCondition && !(0, _PreconditionChecker.getFailingPrecondition)(content.unhighlightCondition) ? _config["default"].useOpacityInsteadOfGreyedOut ? _ErvNestedTiles["default"].opaqueContainer : _ErvNestedTiles["default"].grayscale : '';
      var key = this.getTileIdForContent(content.id);
      var tilePath = [].concat((0, _toConsumableArray2["default"])(this.props.contentPathArray), [content.id]);
      var data = this.state.tileData && this.state.tileData["".concat(content.id)] ? this.state.tileData["".concat(content.id)] : null;

      if (data && data.visible === false) {
        return null;
      }

      var titleKey = content && content.itemid ? "".concat(content.itemid, "_title") : null;
      var subtitleKey = content && content.itemid ? "".concat(content.itemid, "_subtitle") : null;
      var title = _config["default"].usesFlexMenu ? content.itemid && titleKey ? (0, _strings.getString)(titleKey) : content.title : content.title ? content.title : null;
      var subtitle = _config["default"].usesFlexMenu ? content.itemid && subtitleKey ? (0, _strings.getString)(subtitleKey) : content.subtitle : content.subtitle ? content.subtitle : null; // tile strings will be supplied by translations in crowdin, do not usw translation from flexmenu
      // if (!title || title === titleKey) {
      //   title = data && data.title ? data.title : content.title
      // }
      // if (!subtitle || subtitle === subtitleKey) {
      //   subtitle = data && data.subtitle ? data.subtitle : content.subtitle
      // }

      var willBeOpened = this.state.tileToOpen === content.id;
      var animated = this.state.animatedTile === content.id;
      var expanded = this.state.expandedTile === content.id;
      var greyedOut = content.unhighlightCondition && !(0, _PreconditionChecker.getFailingPrecondition)(content.unhighlightCondition);
      var hideTileAnimation = _DataStore["default"].getElementByPathImmediately(_DataStore.DATA_STORE_PATHS.KESI_HIDE_TILE_ANIMATION) || false;
      var closeTileFn = hideTileAnimation ? this.closeTileWithoutAnimation : this.closeTile;
      var showDate = this.getShowDateFromPrecondition(content);
      var backGroundColor = data && data.color ? data.color : content.backgroundColor ? content.backgroundColor : null; // if (target.useKeywordForContentGroups && showDate && showDate.isToday) {
      //   backGroundColor = LightenDarkenColor(backGroundColor, 40)
      // }

      var wizardBackDisabled = this.state.wizardNuggetBackFn === false;
      var wizardNextDisabled = this.state.wizardNuggetNextFn === false;
      var wizardCloseDisabled = this.state.wizardNuggetCloseFn === false;
      var onClickFn = null;

      if (isShrinked) {
        onClickFn = function onClickFn() {
          _this4.setState({
            openTileGroup: content.keyword
          });
        };
      } else if (data && data.external === true) {
        onClickFn = function onClickFn() {
          return _this4.openExternalPage(data.menuUrl, content);
        };
      } else if (!this.tileCantBeOpened(content, animated, expanded)) {
        onClickFn = function onClickFn() {
          _this4.setOpenTile(content);
        };
      }

      var renderedTile = /*#__PURE__*/_react["default"].createElement("div", {
        id: "".concat(key, "_container"),
        key: key,
        className: "".concat(_ErvNestedTiles["default"].container, " ").concat(extraClassName),
        style: style.container
      }, expanded && _config["default"].useArrowsInsteadOfButtonsInWizardNugget ? /*#__PURE__*/_react["default"].createElement("div", {
        id: "".concat(key, "_arrow"),
        style: {
          zIndex: 100,
          top: '-1000px',
          width: '100vw',
          height: '100vh',
          margin: 0,
          padding: 0,
          position: 'absolute'
        }
      }, this.state.wizardNuggetBackFn !== null ? /*#__PURE__*/_react["default"].createElement("div", {
        className: _ErvNestedTiles["default"].arrowContainerLeft
      }, /*#__PURE__*/_react["default"].createElement(_icons.ArrowBackIos, {
        style: {
          fill: wizardBackDisabled ? '#696969' : _cssConstants["default"].colors.buttonBackground
        },
        className: _ErvNestedTiles["default"].backArrow,
        onClick: wizardBackDisabled ? null : function () {
          _this4.showNextWizardPage(true);
        }
      })) : null, this.state.wizardNuggetNextFn !== null ? /*#__PURE__*/_react["default"].createElement("div", {
        className: _ErvNestedTiles["default"].arrowContainerRight
      }, /*#__PURE__*/_react["default"].createElement(_icons.ArrowForwardIos, {
        style: {
          fill: wizardNextDisabled ? '#696969' : _cssConstants["default"].colors.buttonBackground
        },
        className: _ErvNestedTiles["default"].nextArrow,
        onClick: wizardNextDisabled ? null : function () {
          _this4.showNextWizardPage(false);
        }
      })) : null, this.state.wizardNuggetCloseFn !== null ? /*#__PURE__*/_react["default"].createElement("div", {
        className: _ErvNestedTiles["default"].arrowContainerRight
      }, /*#__PURE__*/_react["default"].createElement(_icons.Check, {
        style: {
          fill: wizardCloseDisabled ? '#696969' : _cssConstants["default"].colors.buttonBackground
        },
        className: _ErvNestedTiles["default"].nextArrow,
        onClick: wizardCloseDisabled ? null : function () {
          _this4.closeWizard();
        }
      })) : null) : null, /*#__PURE__*/_react["default"].createElement("div", {
        id: key,
        className: "".concat(_ErvNestedTiles["default"].tile).concat(_DeviceInfoHelper["default"].isiOS() ? " ".concat(_ErvNestedTiles["default"].iosFix) : ''),
        ref: expanded ? this.refScroll : null,
        onScroll: this.onLectureScroll,
        onClick: onClickFn,
        style: style.tile
      }, /*#__PURE__*/_react["default"].createElement("div", {
        className: _ErvNestedTiles["default"].front,
        style: style.front
      }, /*#__PURE__*/_react["default"].createElement(_ErvFront["default"], {
        id: content.id,
        type: content.type,
        subtype: content.subtype,
        size: size,
        correctedSize: size * this.props.zoomValue,
        keywords: content.keyword,
        arrowColor: content.arrowColor,
        fontColor: content.fontColor ? content.fontColor : null,
        backgroundColor: backGroundColor,
        enhancedBackgroundColored: content.enhancedBackgroundColored,
        icon: content.icon,
        enhancedIcon: content.enhancedSvgIcon ? content.enhancedSvgIcon : content.enhancedIcon,
        svgIcon: content.svgIcon,
        newSvgIcon: content.newSvgIcon,
        background: content.background,
        enhancedBackground: content.enhancedBackground,
        title: title,
        subtitle: subtitle,
        colorClasses: content.id ? _TilesColorHelper["default"].getColorFromKey(null, content.id, 5) : null // 5 colors are defined in css
        ,
        contentPathArray: tilePath,
        processTime: content.processTime,
        domId: key,
        expanded: expanded,
        animated: animated,
        willBeOpened: willBeOpened,
        closeTile: closeTileFn,
        setBackButtonFunc: this.props.setBackButtonFunc,
        setTitle: this.props.setTitle,
        regionCode: this.state.regionCode,
        cachedRegion: this.props.currentRegionCache,
        regionUnavailable: this.isRegionAvailable(content),
        tileContentDidMount: this.tileContentDidMount,
        fadeOut: this.props.fadeOut,
        greyedOut: greyedOut,
        setCount: this.props.setCount,
        setScrollBarHidden: this.props.setScrollBarHidden,
        setShowFavButton: this.props.setShowFavButton,
        isOnFirstLayer: this.props.isFirstLayer,
        outerCloseTile: this.props.isFirstLayer ? closeTileFn : this.props.closeTile && this.props.outerCloseTile ? this.props.closeTile : this.props.outerCloseTile,
        outerDomId: this.props.isFirstLayer ? key : this.props.domId && this.props.outerDomId ? this.props.domId : this.props.outerDomId,
        scrollFrameId: key,
        isPublished: content.isPublished,
        zoomValue: this.props.zoomValue,
        wasOpenedAutomatically: this.state.tileOpenedAutomatically,
        isShrinked: isShrinked,
        currentDay: showDate.day,
        setWizardArrowFns: this.setWizardArrowFns,
        resetScrollIndicatorFn: this.resetScrollIndicator,
        showNewBanner: content.showNewBanner || false
      }))));

      var id = _KESI2Helper["default"].getLastSpocOrCourseId(this.props.contentPathArray);

      var spocContent = _KESI2Helper["default"].getContentById(id);

      if (_config["default"].useKeywordForContentGroups && isFirstInGroup && showDate && showDate.string) {
        return /*#__PURE__*/_react["default"].createElement(_react["default"].Fragment, null, /*#__PURE__*/_react["default"].createElement("div", {
          className: _config["default"].showProgressBarNextToTiles && spocContent && spocContent.showProgressBar ? _ErvNestedTiles["default"].dateContainerWithProgress : _ErvNestedTiles["default"].dateContainer,
          style: {
            margin: "0 ".concat(_DrupalNestedTileSizes.MARGIN_BETWEEN_TILES * this.props.zoomValue + 20, "px")
          }
        }, /*#__PURE__*/_react["default"].createElement("div", {
          className: _ErvNestedTiles["default"].dateLine
        }), /*#__PURE__*/_react["default"].createElement("div", {
          className: _ErvNestedTiles["default"].date
        }, showDate.string)), renderedTile);
      }

      return renderedTile;
    }
  }, {
    key: "renderExtraProfileInfo",
    value: function renderExtraProfileInfo() {
      return null;
    }
  }, {
    key: "renderShield",
    value: function renderShield(id, spocContent) {
      return null;
    }
  }, {
    key: "closingTile",
    value: function closingTile() {
      return null;
    }
  }, {
    key: "setTileVisibility",
    value: function setTileVisibility(chapterId, isVisible) {
      var _this5 = this;

      var tileVisibility = this.state.tileVisibility;

      if (tileVisibility[chapterId] !== isVisible) {
        tileVisibility[chapterId] = isVisible;
        setTimeout(function () {
          _this5.setState({
            tileVisibility: tileVisibility
          });
        });
      }
    }
  }, {
    key: "render",
    value: function render() {
      var _this6 = this;

      var idToUse = _KESI2Helper["default"].getLastSpocOrCourseId(this.props.contentPathArray);

      if (!idToUse) {
        // return null
        idToUse = _config["default"].rootId;
      }

      var contentTree = _KESI2Helper["default"].getContentTreeByPath(this.props.contentPathArray.slice(0, this.props.contentPathArray.indexOf(idToUse) + 1));

      var chapters = [];

      if (contentTree) {
        if (contentTree.courses && contentTree.courses.length > 0) {
          chapters.push(contentTree.courses);
        }

        if (contentTree.spocs && contentTree.spocs.length > 0) {
          chapters.push(contentTree.spocs);
        }

        if (contentTree.lectures) {
          chapters.push(contentTree.lectures);
        }
      }

      if (chapters && chapters.length > 0) {
        var tiles = this.state.sortedElements.map(function (chapter) {
          return _this6.renderTile(chapter);
        }).filter(function (tile) {
          return tile !== null;
        });
        var goUpButton = this.props.renderFront ? this.renderGoUpButton() : null;
        var oneTileVisible = (0, _keys["default"])(this.state.tileVisibility).some(function (key) {
          return _this6.state.tileVisibility[key];
        });

        if (!oneTileVisible && (0, _keys["default"])(this.state.tileVisibility).length > 0 && this.state.data[_DataStore.DATA_STORE_PATHS.FILTER_FAVORITES]) {
          if (this.props.isFirstLayer && !this.state.expandedTile || !this.props.isFirstLayer) {
            tiles = /*#__PURE__*/_react["default"].createElement("div", {
              style: {
                maxWidth: '70%',
                margin: '0 auto'
              },
              className: _ErvNestedTiles["default"].noTilesText
            }, (0, _strings.getString)('NO_FAVS'));
          }
        }

        var id = _KESI2Helper["default"].getLastSpocOrCourseId(this.props.contentPathArray);

        var spocContent = _KESI2Helper["default"].getContentById(id);

        var contentContainerStyle = "".concat(_ErvNestedTiles["default"].contentContainer);

        if (_DeviceInfoHelper["default"].isiOS()) {
          contentContainerStyle += " ".concat(_ErvNestedTiles["default"].iosFix);
        }

        if (_config["default"].openTilesInFullScreen) {
          contentContainerStyle += " ".concat(_ErvNestedTiles["default"].withoutBottomBar);
        } else {
          if (_config["default"].showBottomBar) {
            contentContainerStyle += " ".concat(_ErvNestedTiles["default"].withBottomBar);
          } else {
            contentContainerStyle += " ".concat(_ErvNestedTiles["default"].withoutBottomBar);
          }
        }

        if (this.state.overflowYHidden) {
          contentContainerStyle += " ".concat(_ErvNestedTiles["default"].overflowHidden);
        } else {
          contentContainerStyle += " ".concat(_ErvNestedTiles["default"].overflowVisible);
        }

        var contentOverlay = "".concat(_ErvNestedTiles["default"].overlay);

        if (_config["default"].openTilesInFullScreen) {
          contentOverlay += " ".concat(_ErvNestedTiles["default"].withoutBottomBar);
        } else {
          if (_config["default"].showBottomBar) {
            contentOverlay += " ".concat(_ErvNestedTiles["default"].withBottomBar);
          } else {
            contentOverlay += " ".concat(_ErvNestedTiles["default"].withoutBottomBar);
          }
        }

        var progressBar = _config["default"].showProgressBarNextToTiles && spocContent && spocContent.showProgressBar ? /*#__PURE__*/_react["default"].createElement(_ProgressBar["default"], {
          zoomValue: this.props.zoomValue,
          elements: this.state.sortedElements,
          openTileGroup: this.state.openTileGroup
        }) : null;

        var content = /*#__PURE__*/_react["default"].createElement("div", {
          id: this.getFrameElementId(),
          className: contentContainerStyle,
          onTouchMoveCapture: this.onScroll
        }, this.renderShield(id, spocContent), goUpButton, progressBar, tiles, this.state.showOverlay && /*#__PURE__*/_react["default"].createElement("div", {
          id: 'overlay',
          className: contentOverlay
        }), _config["default"].showLectureScrollIndicator && !this.state.scrollIndicatorHidden && this.state.expandedTile ? /*#__PURE__*/_react["default"].createElement("div", {
          className: _ErvNestedTiles["default"].scrollIndicator,
          style: this.state.scrollIndicatorHidden ? {
            display: 'none'
          } : {},
          onClick: function onClick() {
            console.log('scroll indicator clicked');
          }
        }, /*#__PURE__*/_react["default"].createElement(_KeyboardArrowDown["default"], {
          className: _ErvNestedTiles["default"].firstArrow,
          style: {
            fontSize: 'xx-large'
          }
        }), /*#__PURE__*/_react["default"].createElement(_KeyboardArrowDown["default"], {
          className: _ErvNestedTiles["default"].secondArrow,
          style: {
            fontSize: 'xx-large'
          }
        }), /*#__PURE__*/_react["default"].createElement(_KeyboardArrowDown["default"], {
          className: _ErvNestedTiles["default"].thirdArrow,
          style: {
            fontSize: 'xx-large'
          }
        })) : null, _config["default"].openTilesInFullScreen && !this.state.expandedTile ? /*#__PURE__*/_react["default"].createElement("div", {
          className: _ErvNestedTiles["default"].extraPaddingContainer
        }) : null);

        var extraProfileInfo = this.renderExtraProfileInfo();
        var pages = [content];

        if (extraProfileInfo) {
          pages.push(extraProfileInfo);
        }

        if (pages.length > 1) {
          return /*#__PURE__*/_react["default"].createElement(_PageSlide["default"], {
            index: this.state.pageIndex
          }, pages.map(function (page, index) {
            return /*#__PURE__*/_react["default"].createElement("div", {
              key: "page_".concat(index)
            }, page);
          }));
        } else {
          return content;
        }
      }

      return /*#__PURE__*/_react["default"].createElement("div", {
        style: {
          padding: '10%'
        }
      }, "Noch kein Content vorhanden!");
    }
  }]);
  return NonFlippingGenericTiles;
}(_KESI2BasicComponent["default"]);

NonFlippingGenericTiles.propTypes = {
  setCount: _propTypes["default"].func,
  contentPathArray: _propTypes["default"].array.isRequired,
  isRoot: _propTypes["default"].bool,
  isInBackground: _propTypes["default"].bool,
  renderChildrenForId: _propTypes["default"].string,
  hideTileForId: _propTypes["default"].string,
  showOnlyTileWithId: _propTypes["default"].string,
  // overwrites hideTileForId
  onComponentDidUpdate: _propTypes["default"].func,
  animated: _propTypes["default"].bool,
  zoomValue: _propTypes["default"].number.isRequired,
  goUpFunc: _propTypes["default"].func.isRequired,
  showGoUpButton: _propTypes["default"].bool.isRequired,
  showGoUpButtonOnBack: _propTypes["default"].bool.isRequired,
  navigationAllowed: _propTypes["default"].bool.isRequired,
  isHidden: _propTypes["default"].bool,
  renderFront: _propTypes["default"].bool,
  scrollFrameId: _propTypes["default"].string,
  setBackButtonFunc: _propTypes["default"].func.isRequired,
  setTitle: _propTypes["default"].func,
  fadeOut: _propTypes["default"].bool,
  showSettingsDialog: _propTypes["default"].func,
  setCurrentRegionCache: _propTypes["default"].func,
  currentRegionCache: _propTypes["default"].object,
  setScrollBarHidden: _propTypes["default"].func,
  setShowFavButton: _propTypes["default"].func,
  isFirstLayer: _propTypes["default"].bool,
  outerCloseTile: _propTypes["default"].func,
  outerDomId: _propTypes["default"].string
};
NonFlippingGenericTiles.defaultProps = {
  isHidden: false,
  renderChildrenForId: null,
  isRoot: true,
  renderFront: true,
  hideTileForId: null,
  showOnlyTileWithId: null,
  animated: true,
  isInBackground: false,
  scrollFrameId: null,
  rootScrollTop: 0,
  showBackground: false,
  fadeOut: false,
  setTitle: function setTitle() {}
};
var _default = NonFlippingGenericTiles;
exports["default"] = _default;